module.exports = __webpack_public_path__ + "img/hommer_logo_red.875ad710.svg";